/**
 * WFA Summary Metrics Mock
 *
 * Mirrors the four-card results summary from WFAResultPageV2 —
 * training return, out-of-sample return, WFA efficiency, and win rate.
 */

interface MetricCard {
  label: string;
  value: string;
  secondary: string;
  bg: string;
  border: string;
  color: string;
}

const metrics: MetricCard[] = [
  {
    label: 'Training Return',
    value: '+34.2%',
    secondary: 'Sharpe: 1.82',
    bg: 'rgba(59,130,246,0.1)',
    border: 'rgba(59,130,246,0.25)',
    color: '#93c5fd',
  },
  {
    label: 'Out-of-Sample Return',
    value: '+18.7%',
    secondary: 'Sharpe: 1.24',
    bg: 'rgba(168,85,247,0.1)',
    border: 'rgba(168,85,247,0.25)',
    color: '#c4b5fd',
  },
  {
    label: 'WFA Efficiency',
    value: '0.682',
    secondary: 'Good',
    bg: 'rgba(245,158,11,0.1)',
    border: 'rgba(245,158,11,0.25)',
    color: '#fcd34d',
  },
  {
    label: 'Win Rate',
    value: '54.3%',
    secondary: '89 trades',
    bg: 'rgba(34,197,94,0.1)',
    border: 'rgba(34,197,94,0.25)',
    color: '#86efac',
  },
];

export default function WFASummaryMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header">
        <span className="dot" /> Walk-Forward Analysis &mdash; Summary
      </div>
      <div className="platform-mock-body" style={{ padding: '0.75rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.5rem' }}>
          {metrics.map((m) => (
            <div key={m.label} style={{
              background: m.bg,
              border: `1px solid ${m.border}`,
              borderRadius: '0.5rem',
              padding: '0.625rem',
              display: 'flex',
              flexDirection: 'column',
              gap: '0.25rem',
            }}>
              <div style={{ fontSize: '0.5rem', color: '#9ca3af', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                {m.label}
              </div>
              <div style={{ fontSize: '1rem', fontWeight: 700, color: m.color, fontFamily: 'ui-monospace, monospace' }}>
                {m.value}
              </div>
              <div style={{ fontSize: '0.5625rem', color: '#6b7280' }}>
                {m.secondary}
              </div>
            </div>
          ))}
        </div>

        {/* Verdict */}
        <div style={{
          marginTop: '0.625rem',
          background: 'rgba(34,197,94,0.08)',
          border: '1px solid rgba(34,197,94,0.2)',
          borderRadius: '0.375rem',
          padding: '0.5rem 0.625rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
        }}>
          <div style={{
            width: 20, height: 20, borderRadius: '50%',
            background: 'rgba(34,197,94,0.2)',
            border: '1px solid rgba(34,197,94,0.4)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '0.5625rem', fontWeight: 700, color: '#22c55e',
          }}>P</div>
          <div style={{ fontSize: '0.5625rem', color: '#9ca3af' }}>
            <span style={{ color: '#e5e7eb', fontWeight: 600 }}>WFA Passed</span>
            <span> &mdash; Out-of-sample returns are consistent across windows. Efficiency above 50% threshold.</span>
          </div>
        </div>
      </div>
      <div className="platform-mock-caption">
        The WFA summary compares training performance against out-of-sample reality. Efficiency above 0.5 indicates the edge survives unseen data.
      </div>
    </div>
  );
}
